import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Input, Typography } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils"

const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;

const TlcServiceForm = props => {
  const { t } = useTranslation();
  const [serviceTypes, setServiceTypes] = useState([]);
  const [serviceUserTypes, setServiceUserTypes] = useState([]);
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Load all types
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/telecommunication/enums/service-types")
      .then(({ data }) => {
        setServiceTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });

    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/telecommunication/enums/service-users")
      .then(({ data }) => {
        setServiceUserTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        service: props.record.asset.service,
        serviceUser: props.record.asset.serviceUser,
        details: props.record.asset.details,
        value: props.record.asset.value
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        service: props.record.asset.service,
        serviceUser: props.record.asset.serviceUser,
        details: props.record.asset.details,
        value: props.record.asset.value
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;

    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.service = elvis(values.service);
    newAsset.asset.serviceUser = elvis(values.serviceUser);
    newAsset.asset.details = elvis(values.details);
    newAsset.asset.value = elvis(values.value);
    newAsset.valid = isValid;

    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title
        className="details_form_header"
        title="Asset details"
        subTitle="Network Service"
      />

      <Form.Item
        label="Value (€)"
        name="value"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Category"
        name="service"
        tooltip="Service category"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {serviceTypes.map(name => (
            <Option key={name} value={name}>
              {t('telecommunicationEnums.serviceType.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Type of user"
        name="serviceUser"
        tooltip="Type of service user"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {serviceUserTypes.map(name => (
            <Option key={name} value={name}>
              {t('telecommunicationEnums.serviceUser.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
      
      <Form.Item 
        label="Description" 
        name="details"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <TextArea disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default TlcServiceForm;